export default __webpack_public_path__ + "static/media/res.efda15a0.mp4";